"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeObjects = mergeObjects;
exports.debounce = debounce;
exports.isElement = isElement;
exports.isNodeList = isNodeList;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Merge two objects ogether pulling defaults from one and overwtring from the other
 * @param  {object} obj           user supplied argument object
 * @param  {object} defaultObject defautl argument object
 * @return {object}               compiled argument object
 */
function mergeObjects(obj, defaultObject) {
  obj = _objectSpread({}, obj);

  for (var k in defaultObject) {
    if (obj[k] === undefined) {
      obj[k] = defaultObject[k];
    }
  }

  return obj;
}
/**
 * Debounce a funciton
 * @param  {Function} fn function to debounce
 * @param  {int}   ms miliseconds to deboiunce
 * @return {Function}      debounced fucntion
 */


function debounce(fn, ms) {
  var timerId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(function () {
      fn.apply(void 0, args);
      timerId = null;
    }, ms);
  };
}
/**
 * Determine if passed object is a DOM elment
 * @param  {object}  obj
 * @return {Boolean}
 *
 * https://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
 */


function isElement(obj) {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have (works on IE7)
    return _typeof(obj) === 'object' && obj.nodeType === 1 && _typeof(obj.style) === 'object' && _typeof(obj.ownerDocument) === 'object';
  }
}
/**
 * Determine if a passed object is a nodelist
 * @param  {object}  obj
 * @return {Boolean}
 *
 * https://gist.github.com/Tomalak/818a78a226a0738eaade
 */


function isNodeList(obj) {
  var stringRepr = Object.prototype.toString.call(obj);
  return _typeof(obj) === 'object' && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && typeof obj.length !== 'undefined' && (obj.length === 0 || _typeof(obj[0]) === 'object' && obj[0].nodeType > 0);
}